import React from "react";
import BusMarker from "./BusMarker";

export default function BusLiveMap({ vehicles, onSelectVehicle }) {
  return (
    <div className="w-full h-full bg-gray-900 rounded p-2">
      <div className="relative w-full h-full border border-dashed border-gray-700 rounded px-2">
        {vehicles.map((v, i) => (
          <BusMarker
            key={v.id}
            vehicle={v}
            index={i}
            onClick={() => onSelectVehicle(v)}
          />
        ))}
      </div>
    </div>
  );
}
